import { accumulateFsUpdateToVeloCodeUpdate } from './code/fsUpdates.js';
import { accumulatePageFsUpdateToWixSiteFSUpdate } from './page/fsUpdates.js';
export const applyFsUpdates = async (state, updates) => {
    const result = {};
    for (const { path, action } of updates) {
        const structureInfo = state.fileStructure.getStructureInfoByFilePath(path);
        if (structureInfo === null)
            continue;
        if (structureInfo.isPageFile) {
            const { document, code } = await accumulatePageFsUpdateToWixSiteFSUpdate(state, result, structureInfo, {
                path,
                action
            });
            result.code = code;
            result.document = document;
        }
        else if (structureInfo.type === 'code') {
            result.code = await accumulateFsUpdateToVeloCodeUpdate(state, result.code, structureInfo, { path, action });
        }
    }
    return result;
};
